import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {ProjektState} from '../../store/reducer/projektverwaltung.reducer';
import {Observable} from 'rxjs';
import * as moment from 'moment';
import {editMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/mitarbeiter-edit.actions';
import {addMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/mitarbeiter-add.actions';
import {addProjektStart} from '../../store/actions/projekt-add.actions';
import {editProjektStart} from '../../store/actions/projekt-edit.actions';
import {loadAllMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/getAllMitarbeiter.actions';
import {AnredeItem} from '../../../Mitarbeiterverwaltung/anrede.model';
import {MitarbeiterItem} from '../../../Mitarbeiterverwaltung/mitarbeiter.model';
import {State} from '../../../Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {editProjektstufeStart} from '../../store/actions/projektstufe-edit.actions';
import {addProjektstufeStart} from '../../store/actions/projektstufe-add.actions';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';

export interface DialogData{
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  nummer: string;
  name: string;
  start: string;
  ende: string;
  ort: string;
  plz: string;
  str1: string;
  str2: string;
  beschreibung: string;
  auftraggeber: string;
  abteilung: string;
  level: number;
  prjprj: number;
  mitarbeiter: MitarbeiterItem[];
  verrechnen: string;
}

@Component({
  selector: 'app-projekt-formdialog',
  templateUrl: './projekt-formdialog.component.html',
  styleUrls: ['./projekt-formdialog.component.scss']
})

export class ProjektFormdialogComponent implements OnInit {

  public allSelected = false;
  @ViewChild('mySel') private skillSel: MatSelect;
  public $mitarbeiter: Observable<MitarbeiterItem[]>;
  public showDetails = false;
  // tslint:disable-next-line:variable-name
  public last_selection = null;


  private endeDatum;
  private startDatum;
  constructor(
    public dialogRef: MatDialogRef<ProjektFormdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private mitarbeiter: Store<{ mitarbeiterverwaltung: State }>,
    private store: Store<{ projektverwaltung: ProjektState }>
  ) {
    dialogRef.disableClose = true;
    this.$mitarbeiter = mitarbeiter.pipe(select((state) => state.mitarbeiterverwaltung.items));
    // tslint:disable-next-line:triple-equals
    if (data.ende == ''){
      this.endeDatum = null;
    }
    else{
      this.endeDatum = moment(data.ende).format('YYYY-MM-DD');
    }
    // tslint:disable-next-line:triple-equals
    if (data.start == ''){
      this.startDatum = null;
    }
    else{
      this.startDatum = moment(data.start).format('YYYY-MM-DD');
    }
    this.projektForm.patchValue({
      id: data.id,
      name: data.name,
      nummer: data.nummer,
      start: this.startDatum,
      ende: this.endeDatum,
      ort: data.ort,
      plz: data.plz,
      str1: data.str1,
      str2: data.str2,
      mitarbeiter: data.mitarbeiter,
      prjprj: data.prjprj,
      level: data.level,
      abteilung: data.abteilung,
      auftraggeber: data.auftraggeber,
      beschreibung: data.beschreibung,
      verrechnen: data.verrechnen
    });
  }

  public projektForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    nummer: new FormControl('', [Validators.maxLength(255)]),
    start: new FormControl('', [Validators.maxLength(255)]),
    ende: new FormControl('', [Validators.maxLength(255)]),
    ort: new FormControl('', [ Validators.maxLength(255), Validators.pattern('[a-zA-Z áéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ]*')]),
    plz: new FormControl('', [Validators.min(1000), Validators.maxLength(255), Validators.pattern('^[0-9]*$')]),
    str1: new FormControl('', [Validators.maxLength(255)]),
    mitarbeiter: new FormControl(''),
    str2: new FormControl('', [Validators.maxLength(255)]),
    beschreibung: new FormControl('', [Validators.maxLength(255)]),
    auftraggeber: new FormControl('', [Validators.maxLength(255)]),
    abteilung: new FormControl('', [Validators.maxLength(255)]),
    id: new FormControl(''),
    level: new FormControl(''),
    prjprj: new FormControl(''),
    verrechnen: new FormControl('' ),
    });

  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }

  public handleSubmitClick(): void{
    this.projektForm.value.start = this.wandler(this.projektForm.value.start);
    this.projektForm.value.ende = this.wandler(this.projektForm.value.ende);
    const item = this.projektForm.value;

    if (this.data.level){
      if (this.data.id) {
        this.store.dispatch(editProjektStart({item}));
      } else {
        this.store.dispatch(addProjektstufeStart({item}));
      }
    }
    // Projektstufe 0 hier
    else {
      if (this.data.id) {
        this.store.dispatch(editProjektStart({item}));
      } else {
        this.store.dispatch(addProjektStart({item}));
      }
    }

    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  public getErrorMessage(formField: string): string {
    const formControl = this.projektForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.pattern`;
    }
    return 'pages.projektverwaltung.projektDialog.err.generic';
  }

  ngOnInit(): void {
    this.store.dispatch(loadAllMitarbeiterStart({string: sessionStorage.getItem('firmaId')}));
    if (this.data.nummer || this.data.str1 || this.data.str2 || this.data.plz || this.data.ort || this.data.start || this.data.ende || this.data.auftraggeber || this.data.beschreibung || this.data.abteilung ){
      this.showDetails = true;
    }
  }

  toggleAllSelection(): void {
    this.allSelected = !this.allSelected;  // to control select-unselect

    if (this.allSelected) {
      this.skillSel.options.forEach( (item: MatOption) => { item.select(); });
    } else {
      this.skillSel.options.forEach( (item: MatOption) => {item.deselect(); });
    }
  }

  okClicked(): void {
    this.last_selection = this.projektForm.controls.mitarbeiter.value;
    this.skillSel.close();
  }


}
